import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { GeneralResponse, Token } from "../../../types/api";
import { Methods } from "../../constants/CommonConstants";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { IChangeLanguageRequest } from "../../../types/apis/general";

export const ChangeLanguage = async (data: {
  payload: IChangeLanguageRequest;
  token: Token;
}): Promise<GeneralResponse> => {
  const { payload, token } = data;
  try {
    const response = await Api<any, GeneralResponse<IChangeLanguageRequest>>({
      method: Methods.POST,
      endpoint: EndPoints.changeLanguage,
      body: payload,
      token,
      navigateToErrorPageIfThereisError: false,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useChangeLanguage = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    { payload: IChangeLanguageRequest; token: Token }
  > = useMutation({
    mutationFn: ChangeLanguage,
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
